import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJamJar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 6.27,
			y: 1.5,
			width: 11.45,
			height: 3.82,
			rx: 1.91
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M5.32,9.61c1.11,0,1.11-.95,2.23-.95s1.11.95,2.23.95,1.11-.95,2.23-.95,1.11.95,2.22.95,1.12-.95,2.23-.95,1.11.95,2.22.95l1-.47L16.77,5.32H7.23L4.36,9.14Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M18.68,9.14v10.5a2.86,2.86,0,0,1-2.86,2.86H8.18a2.86,2.86,0,0,1-2.86-2.86V9.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M13.91,15.82c0,1.05-.86,2.86-1.91,2.86s-1.91-1.81-1.91-2.86a1.91,1.91,0,0,1,3.82,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 12,
			x2: 12,
			y2: 13.91
		})
	]
});
const ForwardRef = forwardRef(SvgJamJar);
export default ForwardRef;
